import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { StaffInfo } from 'src/app/shared/interfaces/staff-info';
import { IStaffAssistanceContact } from '../interfaces/staff-assistance-contact';

@Injectable({
    providedIn: 'root',
})
export class IneligibilityService {
    private selectedStaffDataSubject: BehaviorSubject<IStaffAssistanceContact> = new BehaviorSubject<IStaffAssistanceContact>(null);
    selectedStaffData$: Observable<IStaffAssistanceContact> = this.selectedStaffDataSubject.asObservable();

    getSelectedStaffData(selectedStaffData: StaffInfo, isAssistanceContact: boolean): void {
        const DATA_OBJECT: IStaffAssistanceContact = {
            selectedStaffData: selectedStaffData,
            isAssistanceContact: isAssistanceContact
        };
        this.selectedStaffDataSubject.next(DATA_OBJECT);
    }
}